import { Fragment, useEffect, useState } from "react";
import React from "react";
import {  Outlet, Navigate,NavLink, useNavigate, useSearchParams } from "react-router-dom";
import Cookie from "js-cookie";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { CircularProgress, Divider } from "@mui/material";
import { Container } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";


import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";


import useHttp from "../hooks/use-http";

const FreshdeskJWT = () => {

  const accessToken = Cookie.get("accessToken");
  const refreshToken = Cookie.get("refreshToken");
  
  const [searchParams] = useSearchParams();
  const client_id = searchParams.get("client_id");
  const state = searchParams.get("state");
  const nonce = searchParams.get("nonce");

  const navigate = useNavigate();
  // const [errorMessage, setErrorMessage] = useState(null);
  // const [isLeadingState, setIsLeadingState] = useState(true);

  // const { isLoading, isError, sendRequest: getFreshWorksToken } = useHttp();

  const {
    isLoading,
    isError,
    message,
    sendRequest: getFreshWorksToken,
  } = useHttp();

  // const getFreshWorksTokenResponse = (res: any) => {
  //   console.log('111111111',res);   
  // };


  const getFreshWorksTokenResponse = (res: any) => {
    

    if (res.data) {
      // console.log('aaaaaaaaaaaaaa',res.data);

      window.location.replace(res.data.url+'?state='+state+'&id_token='+res.data.token)
      // https://senseopsinc.myfreshworks.com/sp/OIDC/715640424430873338/implicit
      // https://senseopsinc.myfreshworks.com/login/sso/?jwt=${token}

    }
  };

  useEffect(() => {
    (accessToken && refreshToken) ? <Outlet />: <Navigate to="/login" />
    // if (!nonce && !state) navigate("/");



    getFreshWorksToken(
      {
        URL: "/api/sso/jwt/freshdesk",
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: {
          nonce: nonce, 
          state: state,
          client_id: client_id
        },
      },
      getFreshWorksTokenResponse
    );

    
    // const token ='eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE3MTY5MDMzMzMsImV4cCI6MTcxNjkwNjkzMywianRpIjoiaWQiLCJzdWIiOiJtYW5vanNAc2Vuc2VvcHMuY29tIiwiZGF0YSI6eyJmaXJzdF9uYW1lIjoiTWFub2oiLCJsYXN0X25hbWUiOiJTIn19.mgTbBlj3wWqqCwFsEDIN19ootn-TUlFRAaHlVKq8KeuZyJygotPTCF19nftTHQpHjoM2J2Jf2OsICIvRV6wIQd6L2W-yVCVlpvydHa6fIkZsby8VWBKYo2gg94jRdCCws6JdluetxJtNGfANXfk48tj3Nj53R-KXCBoKcvHnvjBYntbwkCzgv3ufQxDml8_O9tWuqf5F4iUJ_kFunjL-p8tGgVDt9yHx7E3RikzfW8SjfMg-n6ES9LZJLGwdigDVHENvfjJi-TjlTunU7WjJ5yJQbgBvfDuJdyTkMDWdj5gR9WH28Fcjx-ltxpH7BPRChiSabfZHB3JE8wVuya6ITA'
    

  }, []);


  // useEffect(() => {
    
  // }, []);

  return (
    <Fragment>
      <Container
        component="main"
        maxWidth={false}
        disableGutters
        sx={{ height: "100vh" }}
      >
        <Box
          sx={{
            margin: 0,
            height: "100vh",
          }}
        >
          <Grid container>
            <CssBaseline />

            <Grid
              item
              xs={12}
              sm={12}
              // md={0}
              component={Paper}
              elevation={0}
              square
            >
              <Grid
                sx={{
                  mx: 4,
                  display: "flex",
                  height: "100vh",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "Space-between",
                }}
              >
                <Grid>
                  <Typography variant="body2"> </Typography>
                </Grid>

                <Grid  sx={{ width: "100%", textAlign: "center" }}>
                  <Box mb={3}>
                      {/* <img
                        src="/assets/Primary_logo_black.svg"
                        width="180px"
                      /> */}
                  </Box>
                  <Box>
                    
                    {/* <Typography
                      component="h5"
                      variant="h5"
                      sx={{ fontSize: "30px" }}
                    >
                      
                      Support auth validation
                    </Typography>
                    <Typography
                      variant="body2"
                      mb={2}
                      mt={1}
                      sx={{ color: "gray", fontSize: "16px" }}
                    >
                      Wait for few seconds
                    </Typography>
                    <Divider light={true} /> */}

                    <Box sx={{ display: "flex", justifyContent: "center" }}>                      

                      <LoadingButton
                        loading={true}
                        loadingIndicator={
                          <CircularProgress color="inherit" size={65} />
                        }
                        variant="text"
                        sx={{
                          mt: 3,
                          mb: 2,
                          width: "100px",

                          height: "100px",
                        }}
                      >
                        
                            {/* <CheckCircleOutlineIcon
                              sx={{ color: "#5ACE65", fontSize: "60px" }}
                            /> */}
                          
                      </LoadingButton>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          color:"#5ACE65"
                        }}
                      >
                          {/* <NavLink to="/">
                            {"Back to home"}
                          </NavLink> */}
                       
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid mb={2}>
                
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Fragment>
  );
};

export default FreshdeskJWT;
